// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { ekta as _ekta } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the ekta chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1994
 * Chain Name: Ekta
 * Default Block Explorer: https://ektascan.io
 * Default RPC URL: https://main.ekta.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { ekta } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: ekta,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const ekta = createCommon({
	..._ekta,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
